import { useEffect } from "react"
import { KeyBindingProps } from "@features/keymap/types"
import { useKeymap } from "@features/keymap/useKeymap"
import { shortcuts } from "@features/keymap/shortcuts"

export function KeyBinding({
  bind,
  onKeyDown,
  onKeyUp,
  allowRepeat = false,
  global = false,
}: KeyBindingProps) {
  const { regKey, unregKey } = useKeymap()
  const { id, shortcut, desc } = bind

  useEffect(() => {
    if (onKeyDown) {
      regKey(id, {
        id,
        shortcut,
        handler: onKeyDown,
        desc,
        shortDesc: shortcuts[id].desc,
        trigger: "down",
        allowRepeat,
        global,
      })
    }

    if (onKeyUp) {
      regKey(id, {
        id,
        shortcut,
        handler: onKeyUp,
        desc,
        shortDesc: shortcuts[id].desc,
        trigger: "up",
        allowRepeat,
        global,
      })
    }
    return () => {
      if (onKeyDown) unregKey(id, "down")
      if (onKeyUp) unregKey(id, "up")
    }
  }, [id, shortcut, desc, global, allowRepeat, onKeyDown, onKeyUp, regKey, unregKey])

  return null
}
